/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import Carousel from 'react-multi-carousel';

import { getVideoId } from '@app/helpers';
import { useUser } from '@app/contexts/userContext';
import VideoPreview from '@app/components/molecules/VideoPreview';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import Image from '../../../atoms/Image';

import { SliderContainer, VideoContainer, StyledLeftButton, StyledRightButton } from './style';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 1,
    removeArrowOnDeviceType: true, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 600 },
    items: 3,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

// eslint-disable-next-line react/prop-types
const VideoSlider = ({ videos, ...props }) => {
  const getVideoThumb = (videoId) => `https://img.youtube.com/vi/${videoId.value}/default.jpg`;

  const [videoPresent, setVideoPresent] = React.useState(videos[0]);
  const [activeVideo, setActiveVideo] = React.useState(0)
  const arr = [];
  videos.forEach((item) => {
    const videoId = getVideoId(item);
    arr.push(getVideoThumb(videoId));
  });

  const ButtonGroup = ({ next, previous, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return (
      <>
        <StyledLeftButton onClick={() => previous()}>
          <ChevronLeftIcon fontSize="small" color="primary" />
        </StyledLeftButton>
        <StyledRightButton onClick={() => next()}>
          <ChevronRightIcon fontSize="small" color="primary" />
        </StyledRightButton>
      </>
    );
  };

  ButtonGroup.propTypes = {
    next: PropTypes.func,
    previous: PropTypes.func,
  };
  ButtonGroup.defaultProps = {
    next: () => { },
    previous: () => { },
  };
  return (
    <>
      <VideoContainer>
        <VideoPreview id={videoPresent} value={videoPresent} />
      </VideoContainer>
      <SliderContainer>
        <Carousel
          swipeable={false}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr // means to render carousel on server-side.
          // infinite
          //   autoPlay={this.props.deviceType !== "mobile" ? true : false}
          autoPlaySpeed={2000}
          // autoPlay
          keyBoardControl
          //   customTransition="all .5"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
          //   deviceType={this.props.deviceType}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
          arrows={false}
          customButtonGroup={<ButtonGroup />}
          {...props}
        >
          {arr &&
            arr.map((video, index) => (
              <Image
                className={index === activeVideo && 'active'}
                onClick={() => { setVideoPresent(videos[index]); setActiveVideo(index) }}
                src={video}
                alt=""
              />
            ))}
        </Carousel>
      </SliderContainer>
    </>
  );
};

VideoSlider.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.string).isRequired,
};

VideoSlider.defaultProps = {};

export default VideoSlider;
